// Maximum lengths for the text fields users write.
//
// These mirror the CHECK constraints in migration 055. Keep them in step: the
// database is what actually holds the line, and these exist so a user is told
// "that is too long" by the form rather than by a failed save.
//
// maxLength on an <input> is not a limit. Every browser holds the anon key, so
// a POST straight to PostgREST bypasses the form entirely. That is how a
// 146,854 character team_name reached a live league: the edit-profile modal
// had no maxLength, and no constraint existed behind it either. The columns
// that already had a CHECK, smack_talk among them, were never abused.
//
// Deliberately looser than the old form values. The create and join forms
// capped team names at 20, but two legitimate names were already sitting at 21
// and 23, entered through the unguarded edit path. 30 keeps every real name.

export const TEAM_NAME_MAX  = 30;
export const LEAGUE_NAME_MAX = 40;
export const NAME_MAX        = 40;
export const SMACK_TALK_MAX  = 80;

// RFC 5321 caps an address at 254 characters. Longer than that is not a name
// someone chose, it is something being pasted.
export const EMAIL_MAX = 254;
